import { schema } from 'normalizr'

const shippingAddress = new schema.Entity('shippingAddresses')

export default shippingAddress
